import { useState } from "react"
import styles from "./customer_support.module.scss"

interface Props {
  handleCancellation: (updateLoading: (loading: boolean) => void) => void
}

const CustomerSupport = ({ handleCancellation }: Props) => {
  const [loading, updateLoading] = useState(false)

  const handleContactSupport = () => {
    window.App.loadZendeskMessenger()
  }

  return (
    <div className={styles.customer_support_container}>
      <h1 className="mb2--phone mb2--small-phone">Can we help?</h1>

      <p className={styles.description}>
        Our team is available to assist you on any technical difficulties you may be experiencing.
      </p>

      <div className={styles["support-illustration"]}>
        <div className={styles["bubble-question"]}>?</div>
        <div className={styles["bubble-reply"]}>...</div>
      </div>

      <div className={styles.ctas}>
        <button type="button" className="button-secondary" onClick={handleContactSupport} disabled={loading}>
          Contact support
        </button>
        <button
          type="button"
          className="button-secondary button-outlined"
          onClick={() => handleCancellation(updateLoading)}
          disabled={loading}
        >
          No thanks, just cancel
        </button>
      </div>
    </div>
  )
}

export default CustomerSupport
